import { appStore } from '@databases/redux/store';
import { getDefaultView } from '@databases/utils/database/view/view';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';

import { type OnViewsStateUpdateCommandResponse } from '@canvas/databases-bridge-api/commands';

export function getDatabaseViews(contentId: string): OnViewsStateUpdateCommandResponse {
  const state = appStore.getState();
  const database = selectDatabaseByContentIdRequired(state, { contentId });
  const currentView = getDefaultView(database);

  return {
    views: database.views.map((v) => ({ id: v.id, name: v.name })),
    currentView: {
      id: currentView.id,
      name: currentView.name,
    },
  };
}
